<div class="row">
  <div class="col-12">
    <form [ngClass]="{ 'was-validated': form?.errors?.length> 0 }" novalidate [formGroup]="form">
      <div class="form-row">
        <div class="col-sm-6 col-md-6 col-lg-6">
          <div class="form-group">
            <label for="firstName" class="form-control-label">{{ 'FirstName' | translate }}</label>
            <input class="form-control form-control-sm" id="firstName" formControlName="firstName">
          </div>
        </div>
        <div class="col-sm-6 col-md-6 col-lg-6">
          <div class="form-group">
            <label for="lastName" class="form-control-label">{{ 'LastName' | translate }}</label>
            <input class="form-control form-control-sm" id="lastName" formControlName="lastName">
          </div>
        </div>
      </div>
      <div class="form-row" *ngIf="!contactInfoProps.isObserver">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <label for="addressTypeDBID" class="form-control-label">{{ 'AddressType' | translate }}
              <span class="required"
                *ngIf="form.get('addressTypeDBID').errors?.required != null && form.get('addressTypeDBID').errors?.required">
                * </span>
            </label>
            <select id="addressTypeDBID" class="form-control form-control-sm" formControlName="addressTypeDBID"
              (change)="onAddressTypeChanged()"
              [ngClass]="{ 'is-invalid': form.get('addressTypeDBID').hasError('required') && form.get('addressTypeDBID').touched }">
              <option></option>
              <option *ngFor="let addressType of addressTypes" [ngValue]="addressType.id">
                {{ addressType.value }}
              </option>
            </select>
            <span class="form-control-feedback"
              *ngIf="form.get('addressTypeDBID').hasError('required') && form.get('addressTypeDBID').touched">
              <small class="form-text">{{ 'AddressTypeRequired' | translate }}</small>
            </span>
          </div>
        </div>
      </div>
      <div [formGroup]="address" *ngIf="!contactInfoProps.isObserver">
        <div class="form-row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="form-group">
              <label for="addr1" class="form-control-label">
                {{ 'Address1' | translate}}
                <span class="required"
                  *ngIf="address.get('addr1').errors?.required != null && address.get('addr1').errors?.required">
                  * </span>
              </label>
              <input class="form-control form-control-sm form-control-danger" id="addr1" formControlName="addr1"
                [ngClass]="{ 'is-invalid': (address.get('addr1').hasError('maxlength') || address.get('addr1').hasError('required')) && address.get('addr1').touched }">
              <div class="form-control-feedback"
                *ngIf="address.get('addr1').hasError('required') && address.get('addr1').touched">
                <small class="form-text">{{ 'Address1Required' | translate }}</small>
              </div>
              <div class="form-control-feedback" *ngIf="address.get('addr1').hasError('maxlength')">
                <small class="form-text">{{ 'ErrorMaxLength' | translate:{ P0:
                  address.get('addr1').errors.maxlength.requiredLength } }}
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="form-group">
              <label for="addr2" class="form-control-label"> {{ 'Address2' | translate}} </label>
              <input class="form-control form-control-sm form-control-danger" id="addr2" formControlName="addr2"
                [ngClass]="{ 'is-invalid': address.get('addr2').hasError('maxlength') && address.get('addr2').touched }">
              <div class="form-control-feedback" *ngIf="address.get('addr2').hasError('maxlength')">
                <small class="form-text">{{ 'ErrorMaxLength' | translate:{ P0:
                  address.get('addr2').errors.maxlength.requiredLength } }}
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="form-group">
              <label for="addr3" class="form-control-label"> {{ 'Address3' | translate}} </label>
              <input class="form-control form-control-sm form-control-danger" id="addr3" formControlName="addr3"
                [ngClass]="{ 'is-invalid': address.get('addr3').hasError('maxlength') && address.get('addr3').touched }">
              <div class="form-control-feedback" *ngIf="address.get('addr3').hasError('maxlength')">
                <small class="form-text">{{ 'ErrorMaxLength' | translate:{ P0:
                  address.get('addr3').errors.maxlength.requiredLength } }}
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-sm-6 col-md-6 col-lg-6">
            <div class="form-group">
              <label for="city" class="form-control-label">
                {{ 'City' | translate}}
                <span class="required"
                  *ngIf="address.get('city').errors?.required != null && address.get('city').errors?.required">
                  * </span>
              </label>
              <input class="form-control form-control-sm form-control-danger" id="city" formControlName="city"
                [ngClass]="{ 'is-invalid': (address.get('city').hasError('maxlength') || address.get('city').hasError('required')) && address.get('city').touched }">
              <div class="form-control-feedback"
                *ngIf="address.get('city').hasError('required') && address.get('city').touched">
                <small class="form-text">{{ 'CityRequired' | translate }}</small>
              </div>
              <div class="form-control-feedback" *ngIf="address.get('city').hasError('maxlength')">
                <small class="form-text">{{ 'ErrorMaxLength' | translate:{ P0:
                  form.get('city').errors.maxlength.requiredLength } }}
                </small>
              </div>
            </div>
          </div>
          <div class="col-sm-6 col-md-6 col-lg-6">
            <div class="form-group">
              <label for="province" class="form-control-label">{{ 'Province' | translate }}
                <span class="required"
                  *ngIf="address.get('provinceDBID').errors?.required != null && address.get('provinceDBID').errors?.required">
                  * </span>
              </label>
              <select id="province" #prov="dynamicValidator" (change)="onProvinceChange()"
                dynamicValidator="{{ 'Province' | translate }}" class="form-control"
                [ngClass]="{ 'is-invalid': address?.get('address.provinceDBID')?.dirty && !prov.isValid }"
                formControlName="provinceCode">
                <option *ngFor="let province of provinces" [ngValue]="province.code">
                  {{ getTwoLetterCulture() === 'fr' ? province.valueFrench : province.valueEnglish }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="form-group">
              <label for="postalCode">{{ 'PostalCode' | translate}}
                <span class="required"
                  *ngIf="address.get('postalCode').errors?.required != null && address.get('postalCode').errors?.required">
                  * </span>
              </label>
              <input class="form-control form-control-sm form-control-danger" id="postalCode"
                formControlName="postalCode" onBlurPostalCode
                [ngClass]="{ 'is-invalid': address.get('postalCode').hasError('required') && address.get('postalCode').touched }">
              <span class="form-control-feedback"
                *ngIf="address.get('postalCode').hasError('required') && address.get('postalCode').touched">
                <small class="form-text">{{ 'PostalCodeRequired' | translate }}</small>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row" [formGroup]="workPhone" *ngIf="!contactInfoProps.isObserver">
        <div class="col-sm-9 col-md-9 col-lg-9">
          <div class="form-group">
            <label for="workPhoneNumber" class="form-control-label">
              {{ 'WorkPhone' | translate}}
              <span class="required"
                *ngIf="workPhone.get('value').errors?.required != null && workPhone.get('value').errors?.required">
                * </span>
            </label>
            <input class="form-control form-control-sm form-control-danger" id="workPhoneNumber" formControlName="value"
              #work="dynamicValidator" dynamicValidator="'{{ 'WorkPhone' | translate }}'"
              [ngClass]="{ 'is-invalid': workPhone.get('value').dirty && workPhone.get('value').touched && !work.isValid }"
              onBlurPhone>
          </div>
        </div>
        <div class="col-sm-3 col-md-3 col-lg-3">
          <div class="form-group">
            <label for="extension" class="form-control-label"> {{ 'PhoneExtension' | translate}} </label>
            <input class="form-control form-control-sm form-control-danger" id="extension" formControlName="extension">
          </div>
        </div>
      </div>
      <div class="form-row" [formGroup]="homePhone" *ngIf="!contactInfoProps.isObserver">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <label for="homephonenumber" class="form-control-label">
              {{ 'HomePhone' | translate}}
              <span class="required"
                *ngIf="homePhone.get('value').errors?.required != null && homePhone.get('value').errors?.required">
                * </span>
            </label>
            <input class="form-control form-control-sm form-control-danger" id="homephonenumber" formControlName="value"
              #home="dynamicValidator" dynamicValidator="'{{ 'HomePhone' | translate }}'"
              [ngClass]="{ 'is-invalid': homePhone.get('value').dirty && homePhone.get('value').touched && !home.isValid  }"
              onBlurPhone>
          </div>
        </div>
      </div>
      <div class="form-row" [formGroup]="cellPhone" *ngIf="contactInfoProps.showCellPhone && !contactInfoProps.isObserver">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <label for="cellPhone" class="form-control-label">
              {{ 'CellPhone' | translate}}
              <span class="required"
                *ngIf="cellPhone.get('value').errors?.required != null && cellPhone.get('value').errors?.required">
                * </span>
            </label>
            <input class="form-control form-control-sm form-control-danger" id="cellPhone" formControlName="value"
              #cell="dynamicValidator" dynamicValidator="'{{ 'CellPhone' | translate }}'"
              [ngClass]="{ 'is-invalid': cellPhone.get('value').dirty && cellPhone.get('value').touched && !cell.isValid }"
              onBlurPhone>
          </div>
        </div>
      </div>
      <div class="form-row" [formGroup]="faxPhone" *ngIf="!contactInfoProps.isObserver">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <label for="faxnumber" class="form-control-label">
              {{ 'Fax' | translate}}
              <span class="required"
                *ngIf="faxPhone.get('value').errors?.required != null && faxPhone.get('value').errors?.required">
                * </span>
            </label>
            <input class="form-control form-control-sm form-control-danger" id="faxnumber" formControlName="value"
              #fax="dynamicValidator" dynamicValidator="'{{ 'Fax' | translate }}'"
              [ngClass]="{ 'is-invalid': faxPhone.get('value').dirty && faxPhone.get('value').touched && !fax.isValid }"
              onBlurPhone>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <label for="electronicAddressTypeDBID" class="form-control-label">{{ contactInfoProps.emailTypeDescription | translate }}
              <span class="required"
                *ngIf="form.get('electronicAddressTypeDBID').errors?.required != null && form.get('electronicAddressTypeDBID').errors?.required">
                * </span>
            </label> 
            <select id="electronicAddressTypeDBID" #emailType="dynamicValidator" formControlName="electronicAddressTypeDBID"
              dynamicValidator="{{ contactInfoProps.emailTypeDescription | translate }}" class="form-control"
              [ngClass]="{ 'is-invalid': form?.get('electronicAddressTypeDBID')?.dirty && !emailType.isValid }">
              <option></option>
              <option *ngFor="let emailType of emailTypes" [ngValue]="emailType.id">
                {{ emailType.value }}
              </option>
          </select>
          </div>
        </div>
      </div>
      <div class="form-row" [formGroup]="emailAddress">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <label for="emailAddress" class="form-control-label">
              {{ contactInfoProps.emailDescription | translate}}
              <span class="required"
                *ngIf="emailAddress.get('value').errors?.required != null && emailAddress.get('value').errors?.required">
                * </span>
            </label> 
            <input class="form-control form-control-sm" id="emailAddress" formControlName="value" 
            #value="dynamicValidator" dynamicValidator="{{ contactInfoProps.emailDescription | translate }}"
            [ngClass]="{ 'is-invalid': !value.isValid }"> 
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12" *ngIf="hasConfirmEmail">
          <div class="form-group">
            <label for="confirmEmailAddress" class="form-control-label">
              {{ contactInfoProps.confirmEmailDescription | translate}}
              <span class="required"
                *ngIf="emailAddress.get('confirmValue').errors?.required != null && emailAddress.get('confirmValue').errors?.required">
                * </span>
            </label>
            <input class="form-control form-control-sm" id="confirmEmailAddress" formControlName="confirmValue" (paste)="onPasteEmail($event)" (drop)="onPasteEmail($event)"
            #confirmValue="dynamicValidator" dynamicValidator="{{ contactInfoProps.confirmEmailDescription | translate }}"
            (change)="onConfirmEmailChanged()"
            [ngClass]="{ 'is-invalid': !confirmValue.isValid }">  
          </div>
        </div>
      </div>
      <div class="form-row" [formGroup]="administrativeEmailAddress" *ngIf="contactInfoProps.showDefaultContactEmail">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <label for="defaultContactEmailAddress" class="form-control-label">
              {{ 'DefaultContactEmail' | translate}}
            </label> 
            <input class="form-control form-control-sm" id="defaultContactEmailAddress" formControlName="defaultContactEmailAddress"> 
          </div>
        </div>
      </div>
      <div class="form-row" [formGroup]="administrativeEmailAddress" *ngIf="contactInfoProps.showDefaultContactEmail">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <mrm-checkbox formControlName="useAdminEmail" [showDisabled]="true" (change)="onUseAdminChanged()">
              {{ 'UseThisLocalEmail' | translate }}
              <span text>{{ 'UseThisLocalEmail' | translate }}</span>
            </mrm-checkbox>
          </div>
        </div>
      </div>
      <div class="form-row" [formGroup]="administrativeEmailAddress" *ngIf="contactInfoProps.showAdminEmail">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="form-group">
            <label for="adminEmailAddress" class="form-control-label">
              {{ contactInfoProps.adminEmailDescription | translate}}
              <span class="required"
                *ngIf="administrativeEmailAddress.get('value').errors?.required != null && administrativeEmailAddress.get('value').errors?.required">
                * </span>
            </label> 
            <input class="form-control form-control-sm" id="adminEmailAddress" formControlName="value"
            #adminvalue="dynamicValidator" dynamicValidator="{{ contactInfoProps.adminEmailDescription | translate }}"
            [ngClass]="{ 'is-invalid': !adminvalue.isValid }"> 
          </div>
        </div>
        <div class="col-sm-12 col-md-12 col-lg-12" *ngIf="hasAdminEmail">
          <div class="form-group">
            <label for="confirmAdminEmailAddress" class="form-control-label">
              {{ contactInfoProps.confirmAdminEmailDescription | translate}}
              <span class="required"
                *ngIf="administrativeEmailAddress.get('confirmValue').errors?.required != null && administrativeEmailAddress.get('confirmValue').errors?.required">
                * </span>
            </label>
            <input class="form-control form-control-sm" id="confirmAdminEmailAddress" formControlName="confirmValue" (paste)="onPasteEmail($event)" (drop)="onPasteEmail($event)" 
            #adminconfirmValue="dynamicValidator" dynamicValidator="{{ contactInfoProps.confirmAdminEmailDescription | translate }}"
            [ngClass]="{ 'is-invalid': !adminconfirmValue.isValid }">  
          </div>
        </div>
      </div>
      <div class="form-row" [formGroup]="administrativeEmailAddress"
        *ngIf="contactInfoProps.showDefaultContactAsAdminEmail">
      <div class="col-sm-12 col-md-12 col-lg-12">
        <div class="form-group">
          <label for="adminEmailAddress" class="form-control-label">
            {{ 'DefaultContactEmail' | translate}} 
          </label>
          <input class="form-control form-control-sm" id="adminEmailAddress" formControlName="value"
          #adminvalue="dynamicValidator" dynamicValidator="{{ 'DefaultContactEmail' | translate }}"
          [ngClass]="{ 'is-invalid': !adminvalue.isValid }">
        </div>
      </div>
    </div>
    </form>
  </div>
</div>